var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colored-status",style:(`background-color: ${_vm.color}; color: ${_vm.textColor || 'white'}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }